import React from 'react';
import './WhyChooseUsSection.css'; // Create this CSS file next

// You would ideally use SVG icons here, but for now, using simple placeholders
// Replace with actual icon components or images
const icons = {
  expert: '/assets/icon-expert.svg', // Placeholder path
  appealing: '/assets/icon-appealing.svg', // Placeholder path
  responsive: '/assets/icon-responsive.svg', // Placeholder path
  customer: '/assets/icon-customer.svg', // Placeholder path
};

const WhyChooseUsSection = () => {
  return (
    <section className="why-choose-us-section section" id="why-choose-us">
      <div className="container">
        <h2>Why Choose Us</h2>
        <p className="section-subtitle">We create successful business solutions that our clients succeed.</p>
        <div className="features-grid">
          <div className="feature-item">
            {/* Replace with actual icon component or img tag */}
            <div className="feature-icon">🌟</div> {/* Placeholder icon */}
            <h3>Expertly Built</h3>
            <p>Websites we provide are created by expert web developers that they are highly functional.</p>
          </div>
          <div className="feature-item">
             {/* Replace with actual icon component or img tag */}
            <div className="feature-icon">✨</div> {/* Placeholder icon */}
            <h3>Visually Appealing</h3>
            <p>Beautiful and thoughtfully designed websites we create help attract more customers.</p>
          </div>
          <div className="feature-item">
             {/* Replace with actual icon component or img tag */}
            <div className="feature-icon">💻</div> {/* Placeholder icon */}
            <h3>Responsive Design</h3>
            <p>Websites that we build perform equally well on devices of different types.</p>
          </div>
          <div className="feature-item">
             {/* Replace with actual icon component or img tag */}
            <div className="feature-icon">😊</div> {/* Placeholder icon */}
            <h3>Customer Focused</h3>
            <p>We create websites that easily deliver crucial information about your business to customers.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection; 